module.exports = __webpack_public_path__ + "img/friend-space_ms.e4b413cd.png";